module.exports = __webpack_public_path__ + "img/4_104.40ae0c7c.png";